import React from 'react';

export const StripeSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="32" rx="8" fill="#635BFF" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.752 12.4395C14.752 11.6875 15.368 11.3915 16.392 11.3915C17.864 11.3915 19.72 11.8395 21.192 12.6315V8.08746C19.584 7.44746 18 7.19946 16.4 7.19946C12.472 7.19946 9.86401 9.24746 9.86401 12.6715C9.86401 18.0075 17.216 17.1595 17.216 19.4635C17.216 20.3515 16.44 20.6395 15.36 20.6395C13.752 20.6395 11.704 19.9835 10.08 19.0955V23.6955C11.88 24.4715 13.696 24.7995 15.36 24.7995C19.384 24.7995 22.152 22.8075 22.152 19.3435C22.12 13.5835 14.752 14.6075 14.752 12.4395Z"
				fill="white"
			/>
		</svg>
	);
};
